export default __webpack_public_path__ + "static/media/cif-dk.31dd71cd.svg";